import React, { useState } from 'react';
import { MessageCircle, Radio, Share2, FileText, Scale, Check } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CHANNELS = [
  { key: 'whatsapp', label: 'WhatsApp', Icon: MessageCircle, color: 'bg-green-600' },
  { key: 'radio', label: 'Radio', Icon: Radio, color: 'bg-orange-600' },
  { key: 'social', label: 'Social', Icon: Share2, color: 'bg-blue-600' },
  { key: 'evidence_brief', label: 'Evidence Brief', Icon: FileText, color: 'bg-gray-700' },
  { key: 'policy_brief', label: 'Policy Brief', Icon: Scale, color: 'bg-purple-700' },
];

export const QueueButtons = ({ storyId, token, queues, onChange }) => {
  const [pending, setPending] = useState(null);
  const current = queues || {};

  const toggle = async (channel) => {
    const next = !current[channel];
    setPending(channel);
    try {
      const res = await fetch(`${API_URL}/api/admin/stories/${storyId}/queue`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ channel, queued: next }),
      });
      if (res.ok) {
        const data = await res.json();
        onChange && onChange(data.queues);
      }
    } finally {
      setPending(null);
    }
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="queue-buttons">
      {CHANNELS.map(({ key, label, Icon, color }) => {
        const isQueued = !!current[key];
        const isPending = pending === key;
        return (
          <button
            key={key}
            type="button"
            data-testid={`queue-btn-${key}`}
            onClick={() => toggle(key)}
            disabled={isPending}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition ${
              isQueued
                ? `${color} text-white shadow-sm`
                : 'bg-white border border-gray-200 text-gray-600 hover:border-gray-400'
            } ${isPending ? 'opacity-60' : ''}`}
          >
            {isQueued ? <Check className="w-3 h-3" /> : <Icon className="w-3 h-3" />}
            {isQueued ? `In ${label} Queue` : `Send to ${label}`}
          </button>
        );
      })}
    </div>
  );
};

export default QueueButtons;
